import { render, staticRenderFns } from "./comp_ProductPage-Promos.vue?vue&type=template&id=c1715d02"
import script from "./comp_ProductPage-Promos.vue?vue&type=script&lang=js"
export * from "./comp_ProductPage-Promos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
